import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import type { TrendResult } from '../../types/analytics.types';
import { formatNumber, formatShortDate } from '../../lib/formatters';
import { CHART_COLORS } from '../../lib/visualizationSelector';

interface LineChartDisplayProps {
  data: TrendResult;
}

export function LineChartDisplay({ data }: LineChartDisplayProps) {
  const { dataPoints } = data;

  const chartData = dataPoints.map((point) => ({
    date: point.date,
    label: point.label || formatShortDate(point.date),
    value: point.value,
  }));

  const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
      const item = payload[0].payload;
      return (
        <div className="bg-popover border rounded-lg shadow-lg p-3">
          <p className="font-medium text-foreground">{item.label}</p>
          <p className="text-sm text-muted-foreground">
            {formatNumber(item.value)} patients
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart
        data={chartData}
        margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="label"
          fontSize={12}
          tickMargin={8}
        />
        <YAxis
          tickFormatter={(value) => formatNumber(value)}
          fontSize={12}
        />
        <Tooltip content={<CustomTooltip />} />
        <Line
          type="monotone"
          dataKey="value"
          stroke={CHART_COLORS.primary}
          strokeWidth={2}
          dot={{ fill: CHART_COLORS.primary, strokeWidth: 2, r: 4 }}
          activeDot={{ r: 6, fill: CHART_COLORS.primary }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}
